import { ReactElement } from 'react';
import styles from './device-status.module.scss';
import { Battery, MapPopup } from '@/common/components';
import { Device } from '@/api';
import { UIIcon, UIPopover } from '@/ui';
import { charcoal } from '@/ui/styles';

type DeviceStatusProps = {
    device: Device;
    showLocation?: boolean;
    showBattery?: boolean;
};
export function DeviceStatus(props: DeviceStatusProps): ReactElement {
    const { device, showLocation = true, showBattery = true } = props;
    const { battery, location } = device;
    return (
        <div className={styles.statusCellContainer}>
            {showBattery && (
                <Battery
                    battery={
                        battery
                            ? {
                                  level: battery.level,
                                  isCharging: battery.isCharging,
                                  timestamp: new Date(battery.timestamp)
                              }
                            : null
                    }
                    withLevel={false}
                />
            )}
            {location && showLocation && (
                <UIPopover
                    placement="bottom_left"
                    trigger="hover"
                    width={300}
                    triggerNode={
                        <div className={styles.mapIconContainer}>
                            <UIIcon name="map-pin" size={16} color={charcoal} />
                        </div>
                    }
                >
                    <MapPopup
                        lat={location.lat}
                        lng={location.lng}
                        acc={location.acc}
                        timestamp={new Date(location.ts)}
                    />
                </UIPopover>
            )}
        </div>
    );
}
